// Generated by ts-to-zod
import {z} from "zod";

export const mantineLineChartPropsSchema = z.object({
	h: z.number().optional(),
});
